import React from "react";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";
import { Alert, Button, Form, FormField, TextInput } from "../../ui";
import type { FlashMessage } from "../../../types/state";

interface FormErrorItem {
  code: string;
  message: string;
}

interface EmailInformationFormProps extends WithTranslation {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  formError?: FormErrorItem[];
  message?: FlashMessage | null;
}

function EmailInformationForm({
  t,
  onChange,
  onSubmit,
  formError,
  message,
}: EmailInformationFormProps) {
  const codeId = "EmailInformationForm-code";
  const formErrorId = "EmailInformationForm-errors";
  const messageId = "EmailInformationForm-message";

  return (
    <Form action="/" onSubmit={onSubmit} className="Form LoginForm EmailInformationForm" noValidate>
      {formError && formError.length > 0 ? (
        <Alert variant="error" className="Form-message error" id={formErrorId}>
          {formError.map((error) => (
            <span key={error.code} className="Form-messageLine">
              {error.message}
            </span>
          ))}
        </Alert>
      ) : null}
      {message ? (
        <Alert id={messageId} variant={message.type} className={"Form-message " + message.type}>
          {message.content}
        </Alert>
      ) : null}
      <FormField
        className="Form-line"
        label={t("email_information.label_billed_code")}
        htmlFor={codeId}
        hint={t("email_information.info_billed_code")}
      >
        <TextInput
          className="Form-input LoginForm-code"
          name="code"
          id={codeId}
          onChange={onChange}
          aria-describedby={[formError?.length ? formErrorId : null, message ? messageId : null]
            .filter(Boolean)
            .join(" ")}
        />
      </FormField>
      <div className="Form-line isActionLine">
        <Button type="submit" size="lg" className="Button LoginForm-submit isLarge">
          {t("email_information.button_consult")}
        </Button>
      </div>
    </Form>
  );
}

export default compose(withTranslation())(EmailInformationForm);
